<div class="min-h-screen bg-muted/30 flex flex-col">
  <header class="bg-card border-b border-border sticky top-0 z-20 shrink-0">
    <div class="w-full px-4 h-16 flex items-center justify-between">
      <div
        class="flex items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity"
        routerLink="/modules"
      >
        <img
          [src]="logo()"
          alt="11Care Logo"
          class="h-8 w-auto object-contain"
        />
      </div>

      <div class="flex items-center gap-4">
        <app-dropdown-menu #userMenu className="w-56">
          <div
            appDropdownTrigger
            (click)="userMenu.toggle()"
            class="flex items-center gap-2 cursor-pointer hover:bg-muted/50 p-2 rounded-md transition-colors select-none"
          >
            <div
              class="h-8 w-8 rounded-full border border-border bg-muted flex items-center justify-center overflow-hidden"
            >
              <app-avatar className="h-full w-full">
                <app-avatar-image
                  src=""
                  [alt]="user() || 'User'"
                ></app-avatar-image>
                <app-avatar-fallback class="bg-primary/10 text-xs font-bold text-primary">
                  {{ user()?.slice(0, 2) || 'U' | uppercase}}
                </app-avatar-fallback>
              </app-avatar>
            </div>
            <div class="flex flex-col sm:flex text-left gap-0.5">
              <span class="font-semibold text-foreground text-sm leading-none">{{ user() }}</span>
              <!-- <span class="text-xs text-muted-foreground leading-none">{{ user()?.role }}</span> -->
            </div>
            <lucide-icon
              name="chevron-down"
              class="h-4 w-4 text-muted-foreground transition-transform duration-200"
              [class.rotate-180]="userMenu.isOpen()"
            ></lucide-icon>
          </div>


          <app-dropdown-menu-item (click)="logout()">
            <lucide-icon name="log-out" class="h-4 w-4 mr-2 text-destructive"></lucide-icon>
            <span class="text-destructive">Sair</span>
          </app-dropdown-menu-item>
        </app-dropdown-menu>

        <button
          (click)="logout()"
          class="p-2 rounded-full hover:bg-accent text-muted-foreground transition-colors"
          title="Sair"
        >
          <lucide-icon name="log-out" class="h-5 w-5"></lucide-icon>
        </button>
      </div>
    </div>
  </header>

  <main class="w-full flex-1 flex flex-col px-4 py-8 md:px-8">
    <div class="mb-4">
      <div class="flex items-center gap-2 text-sm text-muted-foreground">
        <a routerLink="/modules" class="hover:text-foreground transition-colors">Início</a>

        @for (crumb of breadcrumbs(); track crumb.path; let last = $last) {
          <lucide-icon name="chevron-right" class="h-4 w-4 opacity-80"></lucide-icon>

          <div class="flex items-center gap-1">
            @if (crumb.isRegistration || crumb.isSettings) {
              <span class="hover:text-foreground transition-colors">{{
                crumb.isRegistration ? 'Cadastros' : 'Configurações'
              }}</span>
              <lucide-icon name="chevron-right" class="h-4 w-4 opacity-80 mr-1"></lucide-icon>
            }

            @if (last) {
              <span class="font-normal text-foreground">{{ crumb.label }}</span>
            } @else {
              <a [routerLink]="crumb.path" class="hover:text-foreground transition-colors">
                {{ crumb.label }}
              </a>
            }
          </div>
        }
      </div>
    </div>

    @if (pageTitle()) {
      <h1 class="text-3xl font-semibold mb-6 text-foreground tracking-tight">{{ pageTitle() }}</h1>
    }

    <router-outlet></router-outlet>
  </main>
</div>
